/* Velvet · vídeos verticais (sections/velvet-videos.liquid)
   - todo vídeo visível toca (a partir de 20% na tela), nenhum card fica parado
   - escolhe a qualidade pelo tamanho do card: lê a lista do HLS e pega a menor que
     cobre o card (480p no celular, 720p no desktop, a menor com economia de dados); quem não toca HLS
     recebe o mp4 da mesma qualidade; se algo falhar, vai o mp4 de 1080p do Liquid
   - o carrossel anda um card a cada X segundos e volta ao início no fim;
     para quando a cliente toca, arrasta, passa o mouse ou foca nele, e retoma depois
   - prefers-reduced-motion: nada toca nem anda sozinho (as setas continuam) */
(function () {
  if (customElements.get('velvet-videos')) return;

  var semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)');
  var PAUSA_APOS_INTERACAO = 8000;
  var TOCA_COM = 0.2;
  var tocaHls = document.createElement('video').canPlayType('application/vnd.apple.mpegurl') !== '';
  var listas = {};

  /* lista de qualidades do HLS: [{ largura, uri }] da menor para a maior */
  function lerLista(endereco) {
    if (!listas[endereco]) {
      listas[endereco] = fetch(endereco).then(function (resposta) {
        if (!resposta.ok) throw new Error(resposta.status);
        return resposta.text();
      }).then(function (texto) {
        var linhas = texto.split(/\r?\n/);
        var opcoes = [];
        linhas.forEach(function (linha, i) {
          var medida = /^#EXT-X-STREAM-INF:.*RESOLUTION=(\d+)x\d+/.exec(linha);
          if (medida && linhas[i + 1] && linhas[i + 1].charAt(0) !== '#') {
            opcoes.push({ largura: Number(medida[1]), uri: new URL(linhas[i + 1].trim(), new URL(endereco, location.href)).href });
          }
        });
        if (!opcoes.length) throw new Error('lista vazia');
        return opcoes.sort(function (a, b) { return a.largura - b.largura; });
      });
    }
    return listas[endereco];
  }

  function escolherFonte(video) {
    if (video.dataset.fonte) return video.fontePronta;
    video.dataset.fonte = 'escolhendo';
    var reserva = video.dataset.mp4;
    var economia = navigator.connection && navigator.connection.saveData;
    /* card de ~210 px no celular: 480p (270 px de largura) já fica nítido em vídeo; 720p no desktop */
    var alvo = economia ? 0 : video.clientWidth * Math.min(window.devicePixelRatio || 1, 1.25);

    var escolha = video.dataset.hls ? lerLista(video.dataset.hls).then(function (opcoes) {
      var opcao = opcoes.find(function (o) { return o.largura >= alvo; }) || opcoes[opcoes.length - 1];
      if (tocaHls) return opcao.uri;
      /* X.HD-720p.2.1Mbps.hls.80404837_.m3u8 -> X.HD-720p-2.1Mbps-80404837.mp4 (mesmo arquivo da Shopify em mp4) */
      var mp4 = opcao.uri.replace(/\.(\w+-\d+p)\.([\d.]+Mbps)\.hls\.(\d+)_\.m3u8(\?.*)?$/, '.$1-$2-$3.mp4');
      if (mp4 === opcao.uri) throw new Error('nome inesperado');
      return mp4;
    }) : Promise.reject(new Error('sem hls'));

    video.fontePronta = escolha.catch(function () { return reserva; }).then(function (fonte) {
      if (!fonte) return;
      if (fonte !== reserva && reserva) {
        video.addEventListener('error', function () {
          video.src = reserva;
          if (video.dataset.tocar === 'sim') video.play().catch(function () {});
        }, { once: true });
      }
      video.src = fonte;
      video.dataset.fonte = 'ok';
    });
    return video.fontePronta;
  }

  function tocar(video) {
    video.dataset.tocar = 'sim';
    escolherFonte(video).then(function () {
      if (video.dataset.tocar !== 'sim' || !video.src) return;
      video.muted = true;
      var promessa = video.play();
      if (promessa && promessa.catch) promessa.catch(function () {});
    });
  }

  function pausar(video) {
    video.dataset.tocar = 'nao';
    if (!video.paused) video.pause();
  }

  class VelvetVideos extends HTMLElement {
    connectedCallback() {
      this.secao = this.closest('.velvet-videos');
      this.itens = Array.from(this.querySelectorAll('.velvet-videos__item'));
      this.intervalo = (Number(this.dataset.intervalo) || 3) * 1000;
      this.pausadoAte = 0;
      this.mouseEmCima = false;
      this.naTela = false;

      this.ligarSetas();
      if (semMovimento.matches || !('IntersectionObserver' in window)) return;

      this.ligarVideos();
      if (this.dataset.auto === 'true' && this.itens.length > 1) this.ligarAuto();
    }

    disconnectedCallback() {
      if (this.observadorVideos) this.observadorVideos.disconnect();
      if (this.observadorPerto) this.observadorPerto.disconnect();
      if (this.observadorSecao) this.observadorSecao.disconnect();
      clearInterval(this.timer);
    }

    ligarVideos() {
      /* perto da tela: já escolhe a fonte (só a lista do HLS, alguns bytes; o vídeo não baixa com preload=none) */
      this.observadorPerto = new IntersectionObserver(function (entradas, observador) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          escolherFonte(entrada.target);
          observador.unobserve(entrada.target);
        });
      }, { rootMargin: '400px' });

      this.observadorVideos = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting && entrada.intersectionRatio >= TOCA_COM) tocar(entrada.target);
          else pausar(entrada.target);
        });
      }, { threshold: [0, TOCA_COM] });

      this.querySelectorAll('video').forEach((video) => {
        this.observadorPerto.observe(video);
        this.observadorVideos.observe(video);
      });
    }

    ligarAuto() {
      var pausar = () => { this.pausadoAte = Date.now() + PAUSA_APOS_INTERACAO; };
      ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin'].forEach((tipo) => {
        this.addEventListener(tipo, pausar, { passive: true });
      });
      this.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.mouseEmCima = true; });
      this.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') { this.mouseEmCima = false; pausar(); } });

      this.observadorSecao = new IntersectionObserver((entradas) => {
        this.naTela = entradas[0].isIntersecting;
      }, { threshold: 0.5 });
      this.observadorSecao.observe(this);

      this.timer = setInterval(() => {
        if (!this.naTela || document.hidden || this.mouseEmCima || Date.now() < this.pausadoAte) return;
        this.andar(1, true);
      }, this.intervalo);
    }

    ligarSetas() {
      if (!this.secao) return;
      var anterior = this.secao.querySelector('[data-videos-anterior]');
      var proximo = this.secao.querySelector('[data-videos-proximo]');
      this.setas = [anterior, proximo];
      var atualizar = () => {
        var fim = this.scrollWidth - this.clientWidth;
        if (anterior) anterior.disabled = this.scrollLeft <= 4;
        if (proximo) proximo.disabled = this.scrollLeft >= fim - 4;
      };
      this.addEventListener('scroll', function () { window.requestAnimationFrame(atualizar); }, { passive: true });
      window.addEventListener('resize', atualizar);
      atualizar();
      if (anterior) anterior.addEventListener('click', () => { this.pausadoAte = Date.now() + PAUSA_APOS_INTERACAO; this.andar(-1, false); });
      if (proximo) proximo.addEventListener('click', () => { this.pausadoAte = Date.now() + PAUSA_APOS_INTERACAO; this.andar(1, false); });
    }

    /* desloca um card; no fim (indo para frente e no automático) volta ao primeiro */
    andar(direcao, voltarNoFim) {
      var inicio = this.getBoundingClientRect().left + parseFloat(getComputedStyle(this).paddingLeft || 0);
      var fim = this.scrollWidth - this.clientWidth;
      var comportamento = semMovimento.matches ? 'auto' : 'smooth';

      if (direcao > 0 && this.scrollLeft >= fim - 4) {
        if (voltarNoFim) this.scrollTo({ left: 0, behavior: comportamento });
        return;
      }

      var deslocamentos = this.itens.map((item) => item.getBoundingClientRect().left - inicio);
      var alvo = direcao > 0
        ? deslocamentos.find((d) => d > 4)
        : deslocamentos.slice().reverse().find((d) => d < -4);
      if (alvo === undefined) return;
      this.scrollBy({ left: alvo, behavior: comportamento });
    }
  }

  customElements.define('velvet-videos', VelvetVideos);
})();
